import React, { useState, useEffect, useRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { isBefore } from "date-fns";
import { useLocation } from "react-router-dom";
import AppointmentConfirmPopup from "../../components/AppointmentConfirmPopup";
import { getAppoitmentList, getPatientList } from "../../actions/appointment";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader";
import { getUserDetail } from "../../utils/helper";
import AppointmentPopupForPractitioner from "../../components/AppointmentPopupForPractitioner";
import AppointmentDetailPopup from "./AppointmentDetailPopup";

const AppointmentScheduler = () => {
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [events, setEvents] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showPatientModal, setShowPatientModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const list = useSelector((state) => state.appointment.appointmentList);
  const location = useLocation();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const calendarRef = useRef(null);
  const id = location.state?.id ?? getUserDetail()?.id;
  const name = location.state?.name ?? "";
  const [selectedEventInfo, setSelectedEventInfo] = useState(null);
  const [showDetailPopup, setShowDetailPopup] = useState(null);
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (startDate && endDate) {
      setIsLoading(true);
      dispatch(
        getAppoitmentList(startDate, endDate, id, () => {
          setIsLoading(false);
        })
      );
    }
  }, [startDate, endDate]);

  useEffect(() => {
    dispatch(getPatientList(id));
  }, []);

  const refreshCalendar = () => {
    setKey(key + 1);
  };

  const mySQLToISO = (mysqlDateTime) => {
    const dateParts = mysqlDateTime?.split(/[- :]/);
    const isoDateTime = new Date(
      Date.UTC(
        dateParts[0],
        dateParts[1] - 1,
        dateParts[2],
        dateParts[3],
        dateParts[4],
        dateParts[5]
      )
    )
      .toISOString()
      .slice(0, 19)
      .replace("T", " ");

    return isoDateTime;
  };

  useEffect(() => {
    let events = list?.map((date) => {
      const start = mySQLToISO(date.start_date);
      const end = mySQLToISO(date.end_date);
      return {
        title: "Booked",
        start: start,
        end: end,
        id: list.id,
        extendedProps: {
          description: date.description,
          id: date.id,
          start_date: date.start_date,
          practitioner_name: date.practitioner_name,
          patient_name: date.patient_name,
          end_date: date.end_date,
          url: date.url,
          title: date.title,
          event_id: date.event_id,
          practitioner_id: date.practitioner_id,
        },
      };
    });

    setEvents(events);
  }, [list]);

  useEffect(() => {
    let id = getUserDetail()?.id;
    if (id) {
      dispatch(getPatientList(id));
    }
  }, []);
  const handleDateSelect = (selectInfo) => {
    setSelectedSlot({
      start: selectInfo.start,
      end: selectInfo.end,
    });
    if (location.pathname.includes("/app/")) {
      setShowPatientModal(true);
    } else {
      setShowModal(true);
    }
  };

  const handleEventClick = (clickInfo) => {
    if (location.pathname.includes("/app/")) {
      setSelectedEventInfo(clickInfo.event.extendedProps);
      setShowDetailPopup(true);
    }
  };

  const handleNext7DaysClick = () => {
    const nextWeekStartDate = new Date(startDate);
    nextWeekStartDate.setDate(nextWeekStartDate.getDate() + 7);
    setStartDate(nextWeekStartDate);

    const nextWeekEndDate = new Date(nextWeekStartDate);
    nextWeekEndDate.setDate(nextWeekEndDate.getDate() + 7);
    setEndDate(nextWeekEndDate);

    if (calendarRef.current) {
      calendarRef.current.getApi().gotoDate(nextWeekStartDate);
    }
  };

  const handlePrevious7DaysClick = () => {
    const nextWeekStartDate = new Date(startDate);
    nextWeekStartDate.setDate(nextWeekStartDate.getDate() - 7);
    setStartDate(nextWeekStartDate);

    const nextWeekEndDate = new Date(startDate);
    setEndDate(nextWeekEndDate);

    if (calendarRef.current) {
      calendarRef.current.getApi().gotoDate(nextWeekStartDate);
    }
  };

  const handleSelectAllow = (selectInfo) => {
    // Allow selection for dates after or equal to today
    return !isBefore(selectInfo.start, new Date());
  };

  const handleDatesSet = (info) => {
    setStartDate(new Date(info.startStr));
    setEndDate(new Date(info.endStr));
  };
  const dayCellDidMount = (arg) => {
    if (!isBefore(arg.date, new Date())) {
      arg.el.classList.add("selectable-date");
    } else {
      arg.el.classList.add("non-selectable-date");
    }
  };
  return (
    <div className="appointment-scheduler">
      <h1>Appointment Scheduler</h1>

      {showModal && (
        <AppointmentConfirmPopup
          setIsLoading={setIsLoading}
          startDate={startDate}
          endDate={endDate}
          closePopup={() => setShowModal(false)}
          selectedSlot={selectedSlot}
          id={id}
          name={name}
          refreshCalendar={refreshCalendar}
        />
      )}
      {showPatientModal && (
        <AppointmentPopupForPractitioner
          setIsLoading={setIsLoading}
          startDate={startDate}
          endDate={endDate}
          closePopup={() => setShowPatientModal(false)}
          selectedSlot={selectedSlot}
          id={id}
          name={name}
          refreshCalendar={refreshCalendar}
        />
      )}

      {showDetailPopup && (
        <AppointmentDetailPopup
          closePopup={() => setShowDetailPopup(false)}
          details={selectedEventInfo}
          startDate={startDate}
          endDate={endDate}
          setIsLoading={setIsLoading}
          refreshCalendar={refreshCalendar}
        />
      )}
      {isLoading && <Loader />}
      <div className="d-flex justify-content-end mb-2">
        {startDate > new Date() && (
          <button className="btn btn-orange" onClick={handlePrevious7DaysClick}>
            Previous 7 Days
          </button>
        )}
        <button className="btn btn-orange" onClick={handleNext7DaysClick}>
          Next 7 Days
        </button>
      </div>

      <FullCalendar
        key={key}
        ref={calendarRef}
        initialDate={startDate}
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        selectable={true}
        select={handleDateSelect}
        events={events}
        selectAllow={handleSelectAllow}
        headerToolbar={false}
        slotMinTime="07:00:00"
        slotMaxTime="20:00:00"
        eventDisplay="booked"
        eventBackgroundColor="orange"
        eventBorderColor="orange"
        eventTextColor="#FFF"
        allDaySlot={false}
        height={675}
        datesSet={handleDatesSet}
        dayCellDidMount={dayCellDidMount}
        eventClick={handleEventClick}
      />
    </div>
  );
};

export default AppointmentScheduler;
